import { create } from 'zustand'

interface ChatStore {
  recentChatPage: number | null
  setRecentChatPage: (page: number | null) => void
}

export const useChatStore = create<ChatStore>(set => ({
  recentChatPage: null,
  setRecentChatPage: (page: number | null) => set({ recentChatPage: page })
}))
